
<template>
    <div ref="listWrap">
        <wrapper-list
                @add="paasAddPage"
                @calculate="paasCalculate"
                @clear="paasClearFile"
                ref="wrapperList" >
            <Form class="list-query-wrap" slot="query" :model="queryParam" :label-width="defaultLabelWidth" ref="queryForm">
                <row class="list-query-row">
                    <FormItem label="文件名称:" class="list-query-item" >
                        <Input  v-model="queryParam.query_LIKE_filename" placeholder=""
                                @on-change="queryTableDatas" clearable />
                    </FormItem>
                </row>
            </Form>
            <Table slot="table" stripe border :height="tableHeight"
                   :data="tableData"
                   :columns="tableColumns"
                   @on-selection-change="selectTableDataChange"
                   @on-sort-change="sortTableData"
                   :no-data-text="noDataText">
            </Table>
            <Page slot="page"  :total="totalRecords"
                  show-total show-sizer
                  @on-change="changePage"
                  @on-page-size-change="changePageSize">
            </Page>
        </wrapper-list>
    </div>
</template>
<script>
    import wrapperList from "@components/paas/wrapper-list";
    import metaList from "@assets/js/list/meta-list.js";
    import CellBar from '@components/paas/cell-bar' //列表内操作
    import {clearFile} from "@api/upload.js";
    export default {
        name: "list",
        mixins: [ metaList ],
        components: { wrapperList  ,CellBar},
        data() {
            return {
                serviceUrl:"/sys/file",  //每个页面访问后台服务器的路径
                currentIdFiledName: 'id',
                queryParam:{
                    query_LIKE_filename:"",
                },
                defaultLabelWidth:200,
                tableColumns:[
                    {
                        title: '文件原名称',
                        key: 'filename',
                    },
                    {
                        title: '业务类型',
                        key: 'businessType',
                    },
                    {
                        title: '业务属性',
                        key: 'businessProperty',
                    },
                    {
                        title: '相对路径',
                        key: 'fileSavePath',
                    },
                    {
                        title: '存储位置',
                        key: 'basedictStorage',
                    },
                    {
                        title: '名称',
                        key: 'name',
                    },

                ],
            }
        },
        mounted(){
        },
        methods:{
            /**
             * 清除一天前无效的文件
             */
            paasClearFile(){
                clearFile().then(res => {
                    this.$Message.info("清除文件成功！")
                })
            }
        }
    }
</script>
